import { logger } from '@porsche-code/kado-logger/client';
import { Rum } from '@porsche-code/kado-rum-client';
import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PIcon } from '@porsche-design-system/components-react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

export const ErrorBoundary = ({
  name,
  fallback = <Error />,
  children,
}: {
  name: string;
  fallback?: React.ReactElement;
  children: React.ReactNode;
}) => (
  <ReactErrorBoundary
    onError={(error, info) => {
      Rum.recordError(error as Error);
      logger.error({ name, error, info });
    }}
    fallback={fallback}
  >
    {children}
  </ReactErrorBoundary>
);

const Error = () => (
  <Wrapper>
    <PIcon name="warning" size="xl" />
  </Wrapper>
);

const Wrapper = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '9.375rem',
    color: 'text.contrastHigh',
    textAlign: 'center',
  },
});
